/**
 * Capture First Name and Last Name
 * Also capture the username and check availability
 * */
import { Form } from '@remix-run/react'
import { Input } from "~/components/ui/input"
import { Button } from "~/components/ui/button"
import {Label} from "~/components/ui/label";

interface Props {
    errorMessage?: string
    errorFields?: Array<string>
    defaultValues?: {
        firstName: string
        lastName: string
        userName: string
    }
}
const Names = ({ errorMessage, errorFields, defaultValues }: Props) => {
    console.log()
    console.log({errorFields,errorMessage})
    const isError = errorFields?.includes('userName')
    return (
        <div className={"flex flex-col gap-6 w-full max-w-sm"} >
            <h3 className={'bold mb-6 text-2xl text-white'}>Create account</h3>
            <Form method={'post'}>
                <input type="hidden" name="_action" value="submit-names" />
                <div className="flex flex-col gap-6">
                    <div className="grid gap-3">
                        <Label htmlFor="firstName">First name</Label>
                        <Input
                            id="firstName"
                            name="firstName"
                            placeholder="Joe"
                            required
                            defaultValue={defaultValues?.firstName}
                        />
                    </div>

                    <div className="grid gap-3">
                        <Label htmlFor="lastName">Last name</Label>
                        <Input
                            id="lastName"
                            name="lastName"
                            placeholder="Somebody"
                            required
                            defaultValue={defaultValues?.lastName}
                        />
                    </div>

                    <div className="grid gap-3">
                        <Label htmlFor="userName">Display Name (Shown on leaderboard)</Label>
                        <Input
                            id="userName"
                            name="userName"
                            placeholder="Joe"
                            required
                            defaultValue={defaultValues?.userName}
                        />
                        {isError && (<p className='text-sm p-2 text-red-300'>{errorMessage}</p>)}
                    </div>
                    <div className="grid gap-3">
                        <Button
                            type={'submit'}
                        >Continue</Button>
                    </div>
                </div>
            </Form>
        </div>
    )
}

export default Names
